import React from 'react';

import loadingsSet from './constants/loadingsSet';
import ShowCase from '@components/ShowCase/ShowCase';
import Preview from '@components/ShowCase/Preview/Preview';
import Controls from '@components/ShowCase/Controls/Controls';


const Loadings = () => {
  return (
    <section>
      <article>
        <ul className="showcase-list">
          {
            loadingsSet.map((loadingPreview, i) => (
              <li key={`loadings-showcase-${i}`}>
                <ShowCase codeTemplate={loadingPreview.codeTemplate}>
                  <Preview>
                    { loadingPreview.component }
                  </Preview>
                  <Controls optionsGroup={loadingPreview.optionsGroup}  />
                </ShowCase>
              </li>
            ))
          }
        </ul>
      </article>
    </section>
  );
};

Loadings.displayName = 'LoadingsPage';

export default Loadings;



// WEBPACK FOOTER //
// ./src/containers/elements/Loadings/Loadings.js